export default {
  editableBlock: '',
  securitizeIdInvestor: {},
  createdLegalSigner: {},
  legalSignerList: {},
  legalSignerByIdInfo: {},
};
